export default {
	table: {
		padding: 10,
	},
	toolbar: {
		margin: '0 0 20px 0',
	},
};



// WEBPACK FOOTER //
// ./src/organization/organization.css.js